var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Com,{tag:"component",on:{"next-step":_vm.nextStep}})
}
var staticRenderFns = []

export { render, staticRenderFns }